import React, { useState } from "react";
import styles from "../translations/Translation.module.scss";
import ClearIcon from "@mui/icons-material/Clear";
import DoneIcon from "@mui/icons-material/Done";
import { Grid, TextField } from "@mui/material";

const AddNewTranslation = (props) => {
  const [showDiv, setShowDiv] = useState(true);
  const [key, setKey] = useState("");
  const [en, setEn] = useState("");
  const [translatedValue, setTranslatedValue] = useState("");

  const lan = props.localizedInfo.defaultLanguage.isocode.substr(0, 2);

  const handleChangeKey = (event) => {
    setKey(event.target.value);
  };

  const handleChangeEn = (event) => {
    setEn(event.target.value);
  };

  const handleChangeTranslatedValue = (event) => {
    setTranslatedValue(event.target.value);
  };

  const cancelTranslation = () => {
    setShowDiv(false);
    props.cancelSpecificTranslation();
  };

  const addTranslation = () => {
    setShowDiv(false);
    const updatedLanguage = {
      moduleKey: props.moduleKey,
      key: key,
      en: en,
      es: en,
      vi: en,
      th: en,
      ph: en,
      pt: en,
      [lan]: translatedValue,
    };
    props.addSpecificTranslation(updatedLanguage);
  };

  return (
    <div>
      {showDiv && (
        <Grid container className={styles.translation_header}>
          <Grid item md={3}>
            <TextField
              className={styles.inputField}
              type="text"
              name="topicBox"
              variant="outlined"
              placeholder={props.t("Translations.enterKey")}
              onChange={handleChangeKey}
            />
          </Grid>

          <Grid item md={3}>
            <TextField
              className={styles.inputField}
              type="text"
              name="topicBox"
              variant="outlined"
              placeholder={props.t("Translations.enterEng")}
              onChange={handleChangeEn}
            />
          </Grid>

          <Grid item md={3}>
            <TextField
              className={styles.inputField}
              type="text"
              variant="outlined"
              name="topicBox"
              placeholder={props.t("Translations.enterLan")}
              onChange={handleChangeTranslatedValue}
            />
          </Grid>

          <div className={styles.lanUpdate}>
            <DoneIcon
              fontSize="small"
              style={{ color: "green" }}
              className={styles.button_hover}
              onClick={addTranslation}
            />
            <ClearIcon
              fontSize="small"
              color="secondary"
              className={styles.button_hover}
              onClick={cancelTranslation}
            />
          </div>
        </Grid>
      )}
    </div>
  );
};

export default AddNewTranslation;
